import {
  ADD_NEW_MANIFOLD_MAIN,
  APPTOOLBAR_BASIC_RESET_APP_STATE,
  APPTOOLBAR_RESET_APP_STATE,
  CALCULATIONS_SET_MANIFOLD_SEPARATIONS,
  CALCULATIONS_SET_MANIFOLD_SIZING,
  CHAMBER_BED_CHAMBER_ROWS_REBUILD,
  CHAMBER_TYPE_ID_SC160LP,
  CHAMBER_TYPE_ID_SC310,
  CHANGE_MANIFOLD_PROP_MAIN,
  CLEAR_MANIFOLD_MAIN,
  INLET_MANIFOLD_ID,
  MANIFOLD_RENDER_LOWER,
  MANIFOLD_RENDER_MAIN,
  MANIFOLD_RENDER_UPPER,
  MANIFOLD_SET_ISOLATOR_STATUS,
  MULTIBED_RESET_APP_STATE,
  OUTLET_MANIFOLD_ID,
  PROJECTS_CRUD_RESTORE_STATE,
  REMOVE_BY_IDS_MANIFOLD_MAIN,
  REMOVE_MANIFOLD_MAIN,
  SUB_PROJECTS_CRUD_RESTORE_STATE,
} from "../lib/types";
import { Manifold } from "../lib/manifolds";
import { ManifoldUtils } from "../lib/manifolds/utils";
import { createSelector } from "reselect";
import store from "../store";
import ManifoldService from "../lib/services/manifold-service";
import { ManifoldEntryFormValueType } from "../components/ManifoldEntry";
import produce from "immer";

/**
 *
 * @param state
 * @param action
 * @param isUpper {boolean}
 * @returns {{manifolds: *[]}}
 */
const renderManifolds = (state, action, isUpper = true) => {
  let isUpperManifold = isUpper;
  const {
    chamberRows,
    manifolds,
    chamberType,
    chamberRowSpacing,
    totalStorageProvided,
    chamberbed,
  } = action.payload;
  try {
    const newManifolds = manifolds.map((manifold) => {
      let manifoldOffset = manifold.manifoldOffset;
      const thisManifoldsRow = chamberRows[manifold.letRow];
      const offSet = thisManifoldsRow.offSet;

      isUpperManifold = manifold.isUpper;

      manifold.manifoldType = manifold.isUpper ? "upper" : "lower";

      let structureType;
      thisManifoldsRow.chambers.forEach((chamber) => {
        if (chamber && chamber.upperCapActive && chamber.upperCapAccessory) {
          if (
            chamber.upperCapAccessory.id === INLET_MANIFOLD_ID ||
            chamber.upperCapAccessory.id === OUTLET_MANIFOLD_ID
          ) {
            structureType = chamber.upperCapAccessory.variant;
          }
        }
        if (chamber && chamber.lowerCapActive && chamber.lowerCapAccessory) {
          if (
            chamber.lowerCapAccessory.id === INLET_MANIFOLD_ID ||
            chamber.lowerCapAccessory.id === OUTLET_MANIFOLD_ID
          ) {
            structureType = chamber.lowerCapAccessory.variant;
          }
        }
      });

      let structureSize =
        manifold.manifoldSize[
          structureType === "nyloplast"
            ? "nyloplastStructureSize"
            : "concreteStructureSize"
        ];

      if (!structureSize) {
        const manifoldDataset = ManifoldUtils.getManifoldDatasetByChamberId(
          chamberType.id,
          manifold.manifoldSize.type,
          structureType === "nyloplast"
        );

        const matchingSize = manifoldDataset.find(
          (manifoldDs) => manifoldDs.size === manifold.manifoldSize.size
        );

        if (matchingSize)
          structureSize =
            matchingSize[
              structureType === "nyloplast"
                ? "nyloplastStructureSize"
                : "concreteStructureSize"
            ];
      }

      const manifoldMetadata = ManifoldUtils.getManifoldMetadataByTypeAndSize(
        structureType,
        structureSize
      );

      manifoldOffset =
        [CHAMBER_TYPE_ID_SC160LP, CHAMBER_TYPE_ID_SC310].indexOf(
          chamberType.id
        ) > -1;
       manifoldOffset = manifoldMetadata &&
           (manifoldMetadata.outerDiameter / 12) / 2 > chamberType.width / 2 + chamberRowSpacing;

      const currentChamberCoordinates = {
        row: manifold.letRow,
        col: manifold.letColumn,
      };

      const isManifoldInner = ManifoldService.isManifoldInnerOnChamberRow(
        currentChamberCoordinates,
        chamberRows
      );

      let manifoldTypeId = manifold.isInlet
        ? "INLET_MANIFOLD_ID"
        : "OUTLET_MANIFOLD_ID";

      let config,
        chamberRowMainCoordinatesArray = [],
        chamberRowVoidCoordinatesArray = [];
      if (isManifoldInner) {
        config = ManifoldService.preparesConfigurationPayloadForVoid(
          isUpperManifold,
          manifold.letRow,
          manifold.letColumn,
          chamberType.id,
          manifoldTypeId,
          totalStorageProvided,
          ManifoldService.getDirection(manifold.letRow, chamberbed)
        );

        chamberRowMainCoordinatesArray =
          ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config);

        chamberRowVoidCoordinatesArray = manifold.stubsNumber
          ? isManifoldInner
            ? ManifoldService.buildManifoldVoidArray(config)
            : []
          : [];
      }

      const constructPlacement = ManifoldService.getManifoldConstructPlacement(
        chamberType.id,
        manifoldTypeId,
        totalStorageProvided,
        isManifoldInner
      );

      const removeSecondPipe =
        manifold.hasSecondPipe &&
        (isUpperManifold
          ? !thisManifoldsRow.chambers.find(
              (c) => c.col < manifold.letColumn && c.active
            )
          : !thisManifoldsRow.chambers.find(
              (c) => c.col > manifold.letColumn && c.active
            ));

      const newM = new Manifold(
        manifold.id,
        manifold.isInlet,
        offSet,
        manifold.letRow,
        manifold.letColumn,
        manifold.direction,
        manifold.stubsNumber,
        manifold.spacer,
        manifold.isElevated,
        manifold.hasWeir,
        isUpperManifold,
        manifold.userModified,
        manifold.manifoldSize,
        manifold.manifoldType,
        isManifoldInner,
        {
          mainRow: chamberRowMainCoordinatesArray,
          voidRows: chamberRowVoidCoordinatesArray,
        },
        manifold.hasSecondPipe && removeSecondPipe
          ? false
          : manifold.hasSecondPipe,
        manifold.hasIsolator,
        manifold,
        manifold.mSize
      );
      // build assemble
      newM.assemble(
        chamberRows,
        manifoldOffset,
        state.extraInletStubs,
        state.extraOutletStubs,
        false,
        isUpperManifold,
        currentChamberCoordinates,
        constructPlacement
      );
      return newM;
    });
    return {
      ...state,
      manifolds: [...newManifolds],
    };
  } catch (exception) {
    console.error(
      `main-manifold-reducer renderManifolds() ${exception.message}`
    );
  }
};

/**
 * Creates new manifolds on request, stops using renderManifold()
 * @param state
 * @param action
 * @param isUpper
 * @returns {Manifold}
 */
const createNewManifold = (state, action, isUpper = false) => {
  try {
    const {
      chamberRows,
      electedManifoldMetadata,
      chamberType,
      chamberRowSpacing,
      totalStorageProvided,
      chamberbed,
      refreshManifold,
      flip,
    } = action.payload;

    let isUpperManifold = isUpper;
    let manifoldOffset =
      electedManifoldMetadata && electedManifoldMetadata.manifoldOffset
        ? electedManifoldMetadata.manifoldOffset
        : false;
    const thisManifoldsRow = chamberRows[electedManifoldMetadata.letRow];
    const offSet = thisManifoldsRow.offSet;

    if (electedManifoldMetadata.manifoldType) {
      isUpperManifold = electedManifoldMetadata.manifoldType === "upper";
    }

    let structureType;
    thisManifoldsRow.chambers.forEach((chamber) => {
      if (chamber && chamber.upperCapActive && chamber.upperCapAccessory) {
        if (
          chamber.upperCapAccessory.id === INLET_MANIFOLD_ID ||
          chamber.upperCapAccessory.id === OUTLET_MANIFOLD_ID
        ) {
          structureType = chamber.upperCapAccessory.variant;
        }
      }
      if (chamber && chamber.lowerCapActive && chamber.lowerCapAccessory) {
        if (
          chamber.lowerCapAccessory.id === INLET_MANIFOLD_ID ||
          chamber.lowerCapAccessory.id === OUTLET_MANIFOLD_ID
        ) {
          structureType = chamber.lowerCapAccessory.variant;
        }
      }
    });

    let structureSize =
      electedManifoldMetadata.manifoldSize[
        structureType === "nyloplast"
          ? "nyloplastStructureSize"
          : "concreteStructureSize"
      ];

    if (!structureSize) {
      const manifoldDataset = ManifoldUtils.getManifoldDatasetByChamberId(
        chamberType.id,
        electedManifoldMetadata.manifoldSize.type,
        structureType === "nyloplast"
      );

      const matchingSize = manifoldDataset.find(
        (manifoldDs) =>
          manifoldDs.size === electedManifoldMetadata.manifoldSize.size
      );

      if (matchingSize)
        structureSize =
          matchingSize[
            structureType === "nyloplast"
              ? "nyloplastStructureSize"
              : "concreteStructureSize"
          ];
    }

    const manifoldMetadata = ManifoldUtils.getManifoldMetadataByTypeAndSize(
      structureType,
      structureSize
    );

    manifoldOffset =
      manifoldMetadata &&
      manifoldMetadata.outerDiameter / 12 / 2 >
        chamberType.width / 2 + chamberRowSpacing;

    const currentChamberCoordinates = {
      row: electedManifoldMetadata.letRow,
      col: electedManifoldMetadata.letColumn,
    };

    const isManifoldInner = ManifoldService.isManifoldInnerOnChamberRow(
      currentChamberCoordinates,
      chamberRows
    );

    let manifoldTypeId = electedManifoldMetadata.isInlet
      ? "INLET_MANIFOLD_ID"
      : "OUTLET_MANIFOLD_ID";

    let config = ManifoldService.preparesConfigurationPayloadForVoid(
      isUpperManifold,
      electedManifoldMetadata.letRow,
      electedManifoldMetadata.letColumn,
      chamberType.id,
      manifoldTypeId,
      totalStorageProvided,
      ManifoldService.getDirection(electedManifoldMetadata.letRow, chamberbed)
    );

    const constructPlacement = ManifoldService.getManifoldConstructPlacement(
      chamberType.id,
      manifoldTypeId,
      totalStorageProvided
    );

    const chamberRowMainCoordinatesArray =
      ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config);

    const chamberRowVoidCoordinatesArray = electedManifoldMetadata.stubsNumber
      ? isManifoldInner
        ? ManifoldService.buildManifoldVoidArray(config)
        : []
      : [];

    const removeSecondPipe =
      electedManifoldMetadata.hasSecondPipe &&
      (isUpperManifold
        ? !thisManifoldsRow.chambers.find(
            (c) => c.col < electedManifoldMetadata.letColumn && c.active
          )
        : !thisManifoldsRow.chambers.find(
            (c) => c.col > electedManifoldMetadata.letColumn && c.active
          ));

    let newDirection;
    if (!electedManifoldMetadata.direction) {
      newDirection = ManifoldService.getDirection(
        electedManifoldMetadata.letRow,
        chamberbed,
        false
      );
    } else {
      newDirection = electedManifoldMetadata.direction;
    }

    if (
      electedManifoldMetadata.hasIsolator === undefined &&
      !electedManifoldMetadata.isInlet
    ) {
      electedManifoldMetadata.hasIsolator = false;
    }

    const generatedManifold = new Manifold(
      electedManifoldMetadata.id,
      electedManifoldMetadata.isInlet,
      offSet,
      electedManifoldMetadata.letRow,
      electedManifoldMetadata.letColumn,
      newDirection,
      electedManifoldMetadata.stubsNumber,
      electedManifoldMetadata.spacer,
      electedManifoldMetadata.isElevated,
      electedManifoldMetadata.hasWeir,
      isUpperManifold,
      electedManifoldMetadata.userModified,
      electedManifoldMetadata.manifoldSize,
      electedManifoldMetadata.manifoldType,
      isManifoldInner,
      {
        mainRow: chamberRowMainCoordinatesArray,
        voidRows: chamberRowVoidCoordinatesArray,
      },
      electedManifoldMetadata.hasSecondPipe && removeSecondPipe
        ? false
        : electedManifoldMetadata.hasSecondPipe,
      electedManifoldMetadata.hasIsolator,
      refreshManifold
    ).assemble(
      chamberRows,
      manifoldOffset,
      state.extraInletStubs,
      state.extraOutletStubs,
      false, // do not change, this now comes from elected manifold
      isUpperManifold,
      currentChamberCoordinates,
      constructPlacement,
      flip
    );

    return generatedManifold;
  } catch (error) {
    console.error(
      `At MainManifoldReducer :: createNewManifold() :: ${error.message}`
    );
  }
};

/**
 * It does a copy  of the manifold state
 * @param manifolds
 * @returns {*}
 */
const copyFromPersistedState = (manifolds) => {
  try {
    return manifolds.map((manifold) => {
      return {
        id: manifold._id,
        direction: manifold._direction,
        isInlet: manifold._isInlet,
        isUpper: manifold._isUpper,
        letColumn: manifold._letColumn,
        letRow: manifold._letRow,
        spacer: manifold._spacer,
        stubsNumber: manifold._stubsNumber,
        userModified: manifold._userModified,
        manifoldSize: manifold._manifoldSize,
        hasWeir: manifold._hasWeir,
        isElevated: manifold._isElevated,
        hasSecondPipe: manifold._hasSecondPipe,
        hasIsolator: manifold._hasIsolator,
      };
    });
  } catch (exception) {
    console.error(
      `main-manifold-reducer copyFromPersistedState() ${exception.message}`
    );
  }
};

let initialState = {
  manifolds: [],
  extraInletStubs: 1,
  extraOutletStubs: 0,
};

export let UpperManifoldReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALCULATIONS_SET_MANIFOLD_SIZING:
      const manifoldSizing = action.payload.manifoldSizing;

      if (manifoldSizing === null) {
        return state;
      }

      return {
        ...state,
        ...manifoldSizing,
      };

    case CALCULATIONS_SET_MANIFOLD_SEPARATIONS:
      return {
        ...state,
        ...action.payload.manifoldSizing,
      };

    case MANIFOLD_RENDER_UPPER:
      try {
        return renderManifolds(state, action, true);
      } catch (exception) {
        console.warn("An issue occurred rendering manifolds", exception);
      }
      return state;

    case SUB_PROJECTS_CRUD_RESTORE_STATE:
    case PROJECTS_CRUD_RESTORE_STATE:
      // Functionality now on MainManifoldReducer
      return state;

    case APPTOOLBAR_BASIC_RESET_APP_STATE:
    case MULTIBED_RESET_APP_STATE:
    case APPTOOLBAR_RESET_APP_STATE:
      return initialState;

    default:
      return state;
  }
};

export let LowerManifoldReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALCULATIONS_SET_MANIFOLD_SIZING:
      const manifoldSizing = action.payload.manifoldSizing;

      if (manifoldSizing === null) {
        return state;
      }

      return {
        ...state,
        ...manifoldSizing,
      };

    case CALCULATIONS_SET_MANIFOLD_SEPARATIONS:
      return {
        ...state,
        ...action.payload.manifoldSizing,
      };

    case MANIFOLD_RENDER_LOWER:
      try {
        return renderManifolds(state, action, false);
      } catch (exception) {
        console.warn("An issue occurred rendering manifolds", exception);
      }
      return state;

    case SUB_PROJECTS_CRUD_RESTORE_STATE:
    case PROJECTS_CRUD_RESTORE_STATE:
      // Functionality now on MainManifoldReducer
      return state;

    case APPTOOLBAR_BASIC_RESET_APP_STATE:
    case MULTIBED_RESET_APP_STATE:
    case APPTOOLBAR_RESET_APP_STATE:
      return initialState;

    default:
      return state;
  }
};

/**
 * New main Manifold Reducer
 * @param state
 * @param action
 * @returns {*}
 * @constructor
 */
export let MainManifoldReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALCULATIONS_SET_MANIFOLD_SIZING:
      const manifoldSizing = action.payload.manifoldSizing;

      if (manifoldSizing === null) {
        return state;
      }

      return {
        ...state,
        // ...manifoldSizing
      };

    case CALCULATIONS_SET_MANIFOLD_SEPARATIONS:
      return {
        ...state,
        // ...action.payload.manifoldSizing
      };

    case MANIFOLD_RENDER_MAIN:
      try {
        console.warn("================================================");
        console.warn(
          "============ renderManifolds(state, action, undefined); ======================"
        );
        console.warn(
          "============ ON MANIFOLD_RENDER_MAIN ======================"
        );
        console.warn("============ STOP USING THIS ======================");
        console.warn("================================================");

        // return renderManifolds(state, action, undefined);
        return state;
      } catch (exception) {
        // console.warn("An issue occurred rendering manifolds", exception);
      }
      return state;

    case ADD_NEW_MANIFOLD_MAIN:
      try {
        let newManifold = null;
        const manifolds = state.manifolds;
        const electedManifoldId = action.payload.electedManifoldMetadata.id;
        let stopCreate =
          manifolds.filter((e) => e._id === electedManifoldId).length > 0;

        if (!stopCreate) {
          newManifold = createNewManifold(state, action);
          if (newManifold !== undefined) {
            return {
              ...state,
              manifolds: [...state.manifolds, newManifold],
            };
          }
        }

        return state;
      } catch (exception) {
        console.error(
          `MainManifoldReducer :: ADD_NEW_MANIFOLD_MAIN :: An issue occurred creation of the manifolds ${exception.message}`
        );
      }
      return state;

    case REMOVE_MANIFOLD_MAIN:
      try {
        const manifoldId = action.payload.manifoldId;
        const removeManifoldIndex = state.manifolds.findIndex((manifold) => {
          return manifold._id === manifoldId;
        });

        return {
          ...state,
          manifolds: [
            ...state.manifolds.slice(0, removeManifoldIndex),
            ...state.manifolds.slice(removeManifoldIndex + 1),
          ],
        };
      } catch (exception) {
        console.error(
          `MainManifoldReducer :: REMOVE_MANIFOLD_MAIN :: An issue occurred removing the manifolds ${exception.message}`
        );
      }
      return state;

    case CHANGE_MANIFOLD_PROP_MAIN:
      let { manifoldId, value, type } = action.payload;
      return {
        ...state,
        manifolds: [
          ...state.manifolds.map((manifold) => {
            if (manifold._id === manifoldId) {
              return produce(manifold, (manifoldDraft) => {
                manifoldDraft._userModified = true;
                switch (type) {
                  case ManifoldEntryFormValueType.NUMBER_OF_STUBS:
                    manifoldDraft._stubsNumber = value;
                    break;

                  case ManifoldEntryFormValueType.DIRECTION:
                    manifoldDraft._direction = value;
                    break;

                  case ManifoldEntryFormValueType.GAP:
                    manifoldDraft._spacer = value;
                    break;

                  case ManifoldEntryFormValueType.IS_MANIFOLD_ISOLATOR_ROW:
                    manifoldDraft._hasIsolator = value.hasIsolator;
                    if (value.isElevated)
                      manifoldDraft._isElevated = value.isElevated;
                    if (value.hasWeir) manifoldDraft._hasWeir = value.hasWeir;
                    break;

                  case ManifoldEntryFormValueType.HAS_SECOND_PIPE:
                    manifoldDraft._hasSecondPipe = value;
                    break;

                  case ManifoldEntryFormValueType.MANIFOLD_SIZE:
                    manifoldDraft._manifoldSize = value;
                    break;

                  case ManifoldEntryFormValueType.HAS_WEIR:
                    manifoldDraft._hasWeir = value;
                    manifoldDraft._isElevated = !value;
                    break;

                  case ManifoldEntryFormValueType.HAS_ELEVATED_MANIFOLD:
                    manifoldDraft._isElevated = value;
                    manifoldDraft._hasWeir = !value;
                    break;

                  case ManifoldEntryFormValueType.STRUCTURE_TYPE:
                    const { isElevated, hasWeir, manifoldSize } = value;
                    if (isElevated) manifoldDraft._isElevated = isElevated;
                    if (hasWeir) manifoldDraft._hasWeir = hasWeir;
                    if (manifoldSize)
                      manifoldDraft._manifoldSize = manifoldSize;
                    break;

                  case ManifoldEntryFormValueType.USER_MODIFIED:
                    manifoldDraft._userModified = value;
                    break;

                  default:
                    console.info("Default");
                }

                // Recreate the assembly array, and change props (newManifoldValues) if they are recalculated
                const { assembly, newManifoldValues } =
                  ManifoldService.getAssemblyMeta(
                    manifoldDraft,
                    state,
                    action.payload
                  );

                manifoldDraft._assembly = [...assembly];

                if (
                  newManifoldValues._stubsNumber !== manifoldDraft._stubsNumber
                ) {
                  if (type === ManifoldEntryFormValueType.NUMBER_OF_STUBS) {
                    manifoldDraft._stubsNumber = newManifoldValues._stubsNumber;
                  }
                }
                if (newManifoldValues._direction !== manifoldDraft._direction) {
                  manifoldDraft._direction = newManifoldValues._direction;
                }
              });
            } else {
              return manifold;
            }
          }),
        ],
      };

    case REMOVE_BY_IDS_MANIFOLD_MAIN:
      const { manifoldsIdsSimple } = action.payload;
      const manifoldsIdsArray = manifoldsIdsSimple.map(
        (manifoldSimple) => manifoldSimple.manifoldId
      );
      const cleanArray = state.manifolds.filter(
        (manifold) => manifoldsIdsArray.indexOf(manifold._id) < 0
      );
      const stateDraft = produce(state, (draft) => {
        draft.manifolds = cleanArray;
      });
      return { ...stateDraft };

    case CLEAR_MANIFOLD_MAIN:
      const manifoldsDraft = produce(state.manifolds, (draft) => {
        draft = [];
      });
      return {
        ...state,
        manifolds: manifoldsDraft,
      };

    case SUB_PROJECTS_CRUD_RESTORE_STATE:
    case PROJECTS_CRUD_RESTORE_STATE:
      try {
        let uManifolds = [],
          lManifolds = [],
          mManifolds = [];

        if (action.payload.upperManifolds) {
          const upperManifolds = action.payload.upperManifolds;
          if (
            upperManifolds &&
            upperManifolds.manifolds &&
            upperManifolds.manifolds.length
          ) {
            uManifolds = renderManifolds(
              state,
              {
                payload: {
                  chamberRows: action.payload.chamberbed.chamberRows,
                  manifolds: copyFromPersistedState(upperManifolds.manifolds),
                  chamberType: action.payload.globals.chamberType,
                  chamberRowSpacing: action.payload.globals.chamberRowSpacing,
                  chamberbed: action.payload.chamberbed,
                  totalStorageProvided: action.payload.totalStorageProvided,
                },
              },
              true
            );
          }
        }

        if (action.payload.lowerManifolds) {
          const lowerManifolds = action.payload.lowerManifolds;
          if (
            lowerManifolds &&
            lowerManifolds.manifolds &&
            lowerManifolds.manifolds.length
          ) {
            lManifolds = renderManifolds(
              state,
              {
                payload: {
                  chamberRows: action.payload.chamberbed.chamberRows,
                  manifolds: copyFromPersistedState(lowerManifolds.manifolds),
                  chamberType: action.payload.globals.chamberType,
                  chamberRowSpacing: action.payload.globals.chamberRowSpacing,
                  chamberbed: action.payload.chamberbed,
                  totalStorageProvided: action.payload.totalStorageProvided,
                },
              },
              false
            );
          }
        }

        if (action.payload.mainManifolds) {
          const manifolds = action.payload.mainManifolds;
          if (manifolds && manifolds.manifolds && manifolds.manifolds.length) {
            mManifolds = renderManifolds(
              state,
              {
                payload: {
                  chamberRows: action.payload.chamberbed.chamberRows,
                  manifolds: copyFromPersistedState(manifolds.manifolds),
                  chamberType: action.payload.globals.chamberType,
                  chamberRowSpacing: action.payload.globals.chamberRowSpacing,
                  chamberbed: action.payload.chamberbed,
                  totalStorageProvided: action.payload.totalStorageProvided,
                },
              },
              true
            );
          }
        }
        let returnedManifolds = [];
        if (mManifolds.manifolds) {
          returnedManifolds = [...returnedManifolds, ...mManifolds.manifolds];
        }
        if (lManifolds.manifolds) {
          returnedManifolds = [...returnedManifolds, ...lManifolds.manifolds];
        }
        if (uManifolds.manifolds) {
          returnedManifolds = [...returnedManifolds, ...uManifolds.manifolds];
        }

        return {
          ...state,
          manifolds: [...returnedManifolds],
        };
      } catch (exception) {
        console.error(
          `MainManifoldReducer() : PROJECTS_CRUD_RESTORE_STATE :: ${exception.message}`
        );
      }
      return state;

    case APPTOOLBAR_BASIC_RESET_APP_STATE:
    case MULTIBED_RESET_APP_STATE:
    case APPTOOLBAR_RESET_APP_STATE:
      return initialState;

    case MANIFOLD_SET_ISOLATOR_STATUS:
      return {
        ...state,
        manifolds: [...state.manifolds].map((manifold) => {
          if (manifold._id === action.payload.manifoldId)
            return produce(manifold, (draft) => {
              draft._hasIsolator = action.payload.isIsolator;
            });
          else return manifold;
        }),
      };

    case CHAMBER_BED_CHAMBER_ROWS_REBUILD:
      let manifoldAccessoriesArray = [];
      const { chamberRows } = action.payload;

      chamberRows.forEach((chamberRow) => {
        chamberRow._chambers.forEach((chamber) => {
          const { _upperCapAccessory, _lowerCapAccessory } = chamber;
          const accessory = _upperCapAccessory
            ? _upperCapAccessory
            : _lowerCapAccessory;
          if (accessory) {
            manifoldAccessoriesArray.push({
              _id: accessory["manifoldId"],
              _letRow: chamber["_row"],
              _letColumn: chamber["_col"],
            });
          }
        });
      });

      if (manifoldAccessoriesArray.length > 0) {
        const offendingManifoldsToRemove = [];
        let movingManifolds = state.manifolds.map((manifold) => {
          return produce(manifold, (manifoldDraft) => {
            try {
              const { _letRow, _letColumn } = manifoldAccessoriesArray.find(
                (manifoldAccessory) => manifoldAccessory._id === manifold._id
              );
              const offset = manifold._letRow - _letRow;
              const newAssembly = manifold._assembly.map((stubs) => ({
                ...stubs,
                rowIndex: stubs.rowIndex - offset,
              }));
              manifoldDraft._letRow = _letRow;
              manifoldDraft._letColumn = _letColumn;
              manifoldDraft._assembly = newAssembly;
              manifoldDraft._coordinates = { row: _letRow, col: _letColumn };
            } catch (e) {
              offendingManifoldsToRemove.push(manifold._id);
            }
          });
        });
        let cleanedManifolds = [];
        if (offendingManifoldsToRemove.length > 0) {
          const cleanArray = movingManifolds.filter((manifold) => {
            return offendingManifoldsToRemove.indexOf(manifold._id) < 0;
          });
          cleanedManifolds = produce(state, (draft) => {
            draft.manifolds = cleanArray;
          });
        }

        return {
          ...state,
          manifolds:
            offendingManifoldsToRemove.length > 0
              ? [...cleanedManifolds.manifolds]
              : [...movingManifolds],
        };
      } else {
        return state;
      }
    default:
      return state;
  }
};

// SELECTORS
const getMainManifolds = (state) => state.mainManifolds.manifolds;
const getFullMainManifolds = (state) => state.mainManifolds;
const getChamberbed = (state) => state.chamberbed;
const ManifoldSelectors = {
  getManifoldByIdFromMain: (id) => {
    if (id) {
      try {
        const getManifold = createSelector([getMainManifolds], (manifolds) => {
          return manifolds.find((manifold) => manifold._id === id);
        });
        return getManifold(store.getState());
      } catch (error) {
        console.error(
          `ManifoldSelectors.getManifoldByIdFromMain() :: ${error.message}`
        );
        return [];
      }
    } else {
      return null;
    }
  },

  /**
   * Returns manifolds as upper or lower type
   * @param type
   * @returns {*[]|unknown}
   */
  getManifoldsByType: (type = "upper") => {
    if (type) {
      const getManifold = createSelector(
        [getMainManifolds],
        (mainManifolds) => {
          try {
            return mainManifolds.filter((manifold) =>
              manifold && manifold._manifoldType
                ? manifold._manifoldType === type
                : false
            );
          } catch (error) {
            console.info(
              `ManifoldSelectors.getManifoldsByType : ${error.message}`
            );
            return [];
          }
        }
      );
      return getManifold(store.getState());
    } else {
      return [];
    }
  },

  /**
   * Returns all manifolds of type upper or lower
   * @param type
   * @returns {{}|*[]}
   */
  getFullManifoldsByType: (type = "upper") => {
    if (type) {
      const getManifold = createSelector(
        [getFullMainManifolds],
        (mainManifolds) => {
          let manifoldsObj = { ...mainManifolds };
          try {
            manifoldsObj.manifolds = mainManifolds.manifolds.filter(
              (manifold) => {
                return manifold && manifold._manifoldType
                  ? manifold._manifoldType === type
                  : false;
              }
            );
          } catch (e) {
            console.log(
              `ManifoldSelectors.getFullManifoldsByType : ${e.message}`
            );
            manifoldsObj.manifolds = [];
          }
          return manifoldsObj;
        }
      );
      return getManifold(store.getState());
    } else {
      return [];
    }
  },

  /**
   * Returns the manifoldSizing content, but appear that is not being used.
   * @param type
   * @param property
   * @returns {*[]|*}
   */
  getManifoldsSizingByTypeAndProperty: (
    type = "upper",
    property = "manifoldSizing"
  ) => {
    const getManifold = createSelector(
      [getFullMainManifolds],
      (mainManifolds) => {
        let manifoldsObj = { ...mainManifolds };
        try {
          manifoldsObj.manifolds = mainManifolds.manifolds.filter((manifold) =>
            manifold && manifold._manifoldType
              ? manifold._manifoldType === type
              : false
          );
        } catch (error) {
          console.info(
            `ManifoldSelectors.getManifoldsSizingByTypeAndProperty : ${error.message}`
          );
          manifoldsObj.manifolds = [];
        }
        return manifoldsObj[property];
      }
    );
    return getManifold(store.getState());
  },

  /**
   * Returns all manifolds of purpose inlet or outlet
   * @param purpose: string (default: 'inlet')
   * @returns {{}|*[]}
   */
  getManifoldsByPurpose: (purpose = "inlet") => {
    const getManifold = createSelector([getMainManifolds], (mainManifolds) => {
      try {
        return mainManifolds.filter((m) => {
          try {
            return purpose.toLowerCase().trim() === "inlet"
              ? m._isInlet
              : !m._isInlet;
          } catch (e) {
            return false;
          }
        });
      } catch (e) {
        console.log(`ManifoldSelectors.getManifoldsByPurpose : ${e.message}`);
        return [];
      }
    });
    return getManifold(store.getState());
  },

  /**
   * Will return the array of inner manifolds used for manifold removal
   * @returns {*}
   */
  getInnerManifoldIds: () => {
    const getManifold = createSelector(
      [getFullMainManifolds, getChamberbed],
      (mainManifolds, chamberbed) => {
        let manifoldsArr = [];
        try {
          const numOfRows = chamberbed.numOfRows;
          const numOfChambers = chamberbed.numOfChambers;
          manifoldsArr = mainManifolds.manifolds.filter((manifold) => {
            return (
              manifold._letColumn > 0 && manifold._letColumn + 1 < numOfChambers
            );
          });
        } catch (error) {
          console.info(
            `ManifoldSelectors.getInnerManifoldIds : ${error.message}`
          );
          manifoldsArr = [];
        }
        return manifoldsArr;
      }
    );
    return getManifold(store.getState());
  },

  getAllManifoldIds: () => {
    const getManifold = createSelector(
      [getFullMainManifolds, getChamberbed],
      (mainManifolds, chamberbed) => {
        let manifoldsArr = [];
        try {
          manifoldsArr = mainManifolds.manifolds;
        } catch (error) {
          console.info(
            `ManifoldSelectors.getInnerManifoldIds : ${error.message}`
          );
          manifoldsArr = [];
        }
        return manifoldsArr;
      }
    );
    return getManifold(store.getState());
  },

  bedHasOutlet: () => {
    const getOutlet = createSelector(
      [getFullMainManifolds, getChamberbed],
      (mainManifolds) => {
        let manifoldsArr = [];
        try {
          manifoldsArr = mainManifolds.manifolds.some(
            (manifold) => manifold.isOutlet
          );
        } catch (error) {
          console.info(`ManifoldSelectors.bedHasOutlet : ${error.message}`);
          manifoldsArr = [];
        }
        return manifoldsArr;
      }
    );
    return getOutlet(store.getState());
  },

  countOutlets: () => {
    const countOutlets = createSelector(
      [getFullMainManifolds, getChamberbed],
      (mainManifolds) => {
        let manifoldsArr = [];
        try {
          manifoldsArr = mainManifolds.manifolds.filter(
            (manifold) => manifold.isOutlet === true
          );
        } catch (error) {
          manifoldsArr = [];
        }
        return manifoldsArr.length;
      }
    );
    return countOutlets(store.getState());
  },
};

export default ManifoldSelectors;



// WEBPACK FOOTER //
// ./src/reducers/main-manifold-reducer.js